export default (price) => {
  return `${Math.floor((parseInt(price, 10) || 0) / 100)}`;
};
